import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { DataApi } from 'app/Model/dataApi';

@Injectable({
  providedIn: 'root'
})
export class DataApiService {

  constructor(private http: HttpClient) { }

  GetDataApi(url: string, params: any, seguridad?: boolean) {
    let variable = (seguridad) ? environment.apiUrlS : environment.apiUrl;
    return this.http.get<DataApi>(variable + url, params);
  }

  PostDataApi(url: string, params: any, seguridad?: boolean) {
    let variable = (seguridad) ? environment.apiUrlS : environment.apiUrl;
    return this.http.post<DataApi>(variable + url, params);
  }

  DeleteDataApi(url: string, params: any, seguridad?: boolean) {
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', }),
      body: params
    };
    let variable = (seguridad) ? environment.apiUrlS : environment.apiUrl;

    return this.http.delete<DataApi>(variable + url, options);
  }

  PutDataApi(url: string, params: any, seguridad?: boolean) {
    let variable = (seguridad) ? environment.apiUrlS : environment.apiUrl;

    return this.http.put<DataApi>(variable + url, params);
  }
}
